<template>
	<c-dialog ref="dialog" width="560" @resolve="finishHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="处理记录">
				<c-input name="handle_record" type="textarea" maxlength="500" rows="4"></c-input>
			</c-form-item>
			<c-form-item label="处理附件">
				<c-upload-file name="handle_attachment_files" multiple="9"></c-upload-file>
			</c-form-item>
			<!--处理记录自定义字段控件-->
			<custom-form ref="customForm" work-type="52"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'collabTaskFinish',

		data() {
			return {
				
			}
		},

		methods: {
			/*********打开完成任务弹窗，回显历史处理数据**********/
			open(data) {

				this.$refs.form.clear();
				this.$refs.customForm.init();

				//查询任务详情，回显历史处理记录（重启后再次完成场景）
				this.request({
					url: '/collab/task/detail',
					data: {
						id: data.id
					},
					success: data => {
						this.$refs.form.set({
							id: data.id,
							handle_record: data.handle_record,
							handle_attachment_files: data.handle_attachment_json || [],
							customFieldValues: data.handleCustomFieldValues,
							custom_fields_value_json: data.handle_custom_fields_value_json || {}
						});
					}
				});

				this.$refs.dialog.open({
					//标题过长截断，避免弹框标题溢出
					title: '完成任务【' + this.ellipsisTitle(data.task_title) + '】'
				});
			},

			/*******任务标题截断（超长显示省略号）*****************/
			ellipsisTitle(title) {
				title = title || '';
				return title.length > 12 ? title.slice(0, 12) + '...' : title;
			},

			/*******完成任务提交处理方法********/
			finishHandle (stop, next){
				stop();
				this.$refs.form.submit({
					url: '/collab/task/finish',
					rule: {
						...this.$refs.customForm.rule
					},
					dataFormatter: data => {
						//处理记录自定义字段
						data.handle_custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
						delete data.custom_fields_value_json;
						//处理附件（JSON数组存储）
						let files = data.handle_attachment_files || [];
						data.handle_attachment_json = files.length ? JSON.stringify(files) : '';
						delete data.handle_attachment_files;
						return data;
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '任务已完成',  // 提示内容,
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
